export default class SSEService {
  constructor(projectId, id, date, time) {
    const config = useRuntimeConfig()
    const baseUrl = config.public.baseUrl
    let url = `${baseUrl}/projects/${projectId}/chats/${id}/messages/replay?videoStartDate=${date}&videoPlayingSeconds=${time}`
    this.evtSource = new EventSource(url)
  }

  // Method to handle generic messages
  onMessage(handler) {
    this.evtSource.onmessage = (event) => {
      handler(event.data)
    }
  }

  // Method to handle custom named events like 'chatmessage'
  onEvent(eventName, handler) {
    this.evtSource.addEventListener(eventName, (event) => {
      handler(event.data)
    })
  }

  onError(handler) {
    this.evtSource.onerror = (event) => {
      console.error("EventSource failed:", event)
      handler(event)
    }
  }

  close() {
    this.evtSource.close()
  }
}
